<div class="content">

  <!-- Cards des collaborateurs parents -->
  <div class="card">
    <div class="card-header header-elements-inline" [ngBusy]="busy">
      <h6 class="card-title">Collaborateurs</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3" *ngFor="let collab of collaborateurs">
          <div
            class="card text-center"
            [ngClass]="{'border-primary': selectedCollaborateur?.id === collab.id}"
            style="cursor: pointer;"
            (click)="selectCollaborateur(collab)"
          >
            <div class="card-body">
              <i class="icon-user display-4"></i>
              <h6 class="mt-2">{{ collab.prenom }} {{ collab.nom }}</h6>
              <span class="badge badge-info">
                {{ collab.sous_collaborateurs_count ?? 0 }} collaborateurs
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table des sous-collaborateurs -->
  <div class="card mt-3" *ngIf="selectedCollaborateur">
    <div class="card-header header-elements-inline">
      <h6 class="card-title">
        Sous-collaborateurs de <strong>{{ selectedCollaborateur.prenom }}</strong>
      </h6>
      <div class="heading-elements">
        <button
          [routerLink]="['/collaborateurs/add']"
          [queryParams]="{ parent_id: selectedCollaborateur.id }"
          type="button"
          class="btn btn-info btn-xs"
        >
          <i class="icon-plus2 position-left"></i>Ajouter un sous-collaborateur
        </button>
      </div>
    </div>
    <div class="card-body">
      <table
        class="table perso-table"
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Prénom</th>
            <th>Nom</th>
            <th>Email</th>
            <th>Poste</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>

</div>